<app-admin-header></app-admin-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <app-breadcrumb
        [items]="[{ label: 'Admin' }, { label: 'Business Themes' }]"
        [home]="{ label: 'Home', routerLink: '/home' }"
      ></app-breadcrumb>

      <div class="m-b-20 dis-flex flex-sb">
        <h1 class="font-medium text-70 m-b-0">Business Themes</h1>
        <div class="dis-flex flex-sb">
          <button class="btn primary b2 wd-130px m-r-10" (click)="addTheme()">
            <ng-icon class="lh-1-0 m-r-4" name="hugeAdd01" size="18" />Add Theme
          </button>
          <button class="btn outline b2 wd-130px" (click)="copyData()">
            <ng-icon class="lh-1-0 m-r-4" name="hugeCopy01" size="18" />Copy
            Theme
          </button>
        </div>
      </div>
      <ng-container *ngIf="!isThemeLoading;else loadigData">

      <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 28vh)' }">
        <div class="content">
          <div class="m-t-25">
            <div class="m-b-20" *ngFor="let entry of filteredAndSortedThemes">
              <h3 class="font-medium text-70 m-l-5">{{ entry.year }}</h3>

              <div class="flex flex-wrap">
                <div class="flex flex-wrap" *ngFor="let theme of entry.themes">
                  <p-card
                    class="admin-theme-card dis-flex m-t-5 m-b-5 m-l-5 m-r-5"
                    [ngClass]="theme?.year!= currentYear ? 'disabled-theme-card' : ''"
                  >
                    <ng-template pTemplate="header">
                      <div class="dis-flex flex-sb flex-m theme-header">
                        <p class="fs-12 text-70 m-b-0">{{ theme.year }}</p>
                        <div class="dis-flex">
                          <button
                            class="icon-btn text-primary m-r-10"
                            (click)="selectTheme(theme)"
                            ngbTooltip="Edit Theme"
                          >
                            <ng-icon
                              name="hugeEdit02"
                              size="22"
                              class="lh-1-0"
                            />
                          </button>
                          <button
                            class="icon-btn text-error"
                            (click)="deleteData(theme)"
                            ngbTooltip="Delete Theme"
                          >
                            <ng-icon
                              name="hugeDelete02"
                              size="22"
                              class="lh-1-0"
                            />
                          </button>
                        </div>
                      </div>
                    </ng-template>
                    <p class="dis-flex m-b-0">
                      <span
                        class="cardcolor"
                        [ngStyle]="{ 'background-color': theme.color }"
                      ></span
                      >{{ theme.value }}
                    </p>
                  </p-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-scrollPanel>

      </ng-container>
    </div>

    <div class="group-details">
      <p-dialog
        class="action-item-modal b1 font-medium admin-theme-modal"
        header="{{ theme.theme_id ? 'Update Theme' : 'Add Theme' }}"
        [modal]="true"
        [(visible)]="visible"
        [style]="{ width: '50rem' }"
      >
        <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
          <div
            class="users-form-container radius-8 border-20 p-t-15 p-b-15 p-l-15 p-r-15"
          >
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 50vh)' }"
            >
              <form
                #themeForm="ngForm"
                (ngSubmit)="
                  themeForm.form.valid && theme.theme_id
                    ? updateData(themeForm)
                    : addData(themeForm)
                "
                novalidate
              >
                <div>
                  <div class="flex flex-column mb-3">
                    <label for="value" class="b3 text-90"
                      >Name <span class="mandatory">*</span></label
                    >
                    <input
                      id="value"
                      name="value"
                      class="b3 text-90"
                      type="text"
                      [(ngModel)]="theme.value"
                      #value="ngModel"
                      required
                    />
                    <span
                      class="text-danger"
                      *ngIf="
                        (value.touched || themeForm.submitted) && value.errors
                      "
                    >
                      Value is required
                    </span>
                  </div>
                  <div class="dis-flex">
                    <div class="flex flex-column mb-3 m-r-40">
                      <label for="color" class="b3 text-90"
                        >Color <span class="mandatory">*</span></label
                      >
                      <input
                        id="color"
                        name="color"
                        class="b3 text-90 theme-color-input"
                        type="color"
                        [(ngModel)]="theme.color"
                        #color="ngModel"
                        required
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          (color.touched || themeForm.submitted) && color.errors
                        "
                      >
                        Color is required
                      </span>
                    </div>
                    <div class="flex flex-column mb-3">
                      <label for="color" class="b3 text-90"
                        >Year <span class="mandatory">*</span></label
                      >
                      <input
                        type="number"
                        class="b3 text-90"
                        id="year"
                        name="year"
                        [(ngModel)]="theme.year"
                        #year="ngModel"
                        required
                      />
                      <span
                        class="text-danger"
                        *ngIf="(year.touched || themeForm.submitted) && year.errors"
                      >
                        Year is required
                      </span>
                    </div>
                  </div>
                </div>
                <div class="dis-flex flex-r m-t-20 m-b-20">
                  <button
                    class="btn outline wd-150px m-r-10"
                    type="button"
                    (click)="closeModal()"
                  >
                    Cancel
                  </button>
                  <button class="btn primary wd-150px" type="submit">
                    {{ theme.theme_id ? "Update" : "Save" }}
                  </button>
                </div>
              </form>
            </p-scrollPanel>
          </div>
        </div>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loadigData>
  <app-shimmer-list [count]="15"></app-shimmer-list>
</ng-template>